export const labels = ["Activity", "Commands", "Data"];
export const keysToDisplay = [
    "total messages",
    "total commands used",
    "total data updates",
];